import qs from 'query-string';
import { apiConfig } from '../api-config';

export interface GetStepRegisterParams {
  cdUser: number;
  cdTerritory: string;
  tokenKey: string;
}

export const getStepRegister = async (params: GetStepRegisterParams) => {
  const query = qs.stringify(params);
  return apiConfig
    .get(`/api/StepRegister/get-by-cd-user?${query}`)
    .then((resp) => resp.data.objectResult)
    .catch((err) => ({ hasErrors: true, err }));
};
